$(document).ready(function () {
    const _URL = window.URL || window.webkitURL;
    if ($("image-uploader").length) {
        $("image-uploader").each(function (v) {
            var that = $(this);
            var oldImages = that.attr('data-images')?JSON.parse(that.attr('data-images')):[];
            var isModerator = that.data('moderator');
            var uploader = new Vue({
                el: that.get(0),
                template: '<div class="form-group-file image-uploader row" :class="{loading: isLoading}">' +
                    '<label class="file-other">' +
                    '                <input :disabled="isLoading" @change="uploaded" type="file" name="fileToUploadU"/>' +
                    '                <span class="btn btn-main">' +
                    '                <span class="menu-icon"><img src="/public/frontend/img/icons/account/attachment.svg"' +
                    '                alt="attachment"></span>' +
                    '                <span>'+__('choice_file')+'</span>\n' +
                    '                </span>' +
                    '                </label>' +
                    '                <div class="alert alert-info" v-if="!error">'+__('min_image_text')+'</div>' +
                    '                <div class="alert alert-danger" v-if="error">{{error}}</div>' +
                    '<div class="uploaded-images col-md-12">' +
                    '<input type="hidden" name="images" :value="getImageVal()"/>' +
                    '<div class="uploaded-image " v-for="(image, index) in images">' +
                    '<span v-if="!index">'+__('main_image')+'</span>' +
                    '<img :src="\'/\'+image"/>' +
                    '<button v-if="!!index" @click.stop="setMain(index)" style="bottom: 64px;" class="btn btn-info" type="button">'+__('make_main_image')+'</button>' +
                    '<button v-if="moderator" @click="showSlider(index)" style="bottom: 24px;" class="btn btn-info" type="button">'+__('see_fullscreen')+'</button>' +
                    '<button @click.stop="deleteImage(image)" class="btn btn-danger" type="button">'+__('deleted')+'</button>' +
                    '  </div>' +
                    '  </div>' +
                    '</div>',
                data: function () {
                    return {
                        images: oldImages ? oldImages : [],
                        error: '',
                        moderator: isModerator ? isModerator : false,
                        isLoading: false,
                        limit: 8
                    }
                },
                methods: {
                    getImageVal() {
                        return JSON.stringify(this.$data.images);
                    },
                    uploaded(e) {
                        let that = this;
                        that.$data.error = '';
                        var files = e.target.files;
                        if ((file = files[0])) {
                            img = new Image();
                            var objectUrl = _URL.createObjectURL(file);
                            that.$data.isLoading = true;
                            img.onload = function () {
                                var sizes = [1000, 1000];
                                var errors = [];
                                if (this.width < sizes[0]) {
                                    errors.push(__('width_image', {':sizes':sizes[0]}))
                                }
                                if (this.height < sizes[1]) {
                                    errors.push(__('height_image', {':sizes':sizes[1]}))
                                }
                                if ((file.size / (1024 * 1024)).toFixed(2) > 2) {
                                    errors.push(__('size_image'))
                                }
                                if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                                    errors.push(__('type_file'))
                                }
                                if (errors.length) {
                                    that.$data.error = errors.join('. ');
                                    e.target.value = '';
                                    e.target.files.length = 0;
                                    that.$data.isLoading = false;
                                } else {
                                    var fd = new FormData;
                                    fd.append('FileData', file);
                                    $.ajax({
                                        url: '/profile/shop_settings/upload_product_image',
                                        data: fd,
                                        processData: false,
                                        contentType: false,
                                        type: 'POST',
                                        success: function (data) {
                                            that.$data.isLoading = false;
                                            that.$data.images.push(data);
                                            console.log(that.$data.images);
                                            that.$data.error = '';
                                            e.target.value = '';
                                            e.target.files.length = 0;
                                        },
                                        error: function (msg) {
                                            that.$data.isLoading = false;
                                            alert(msg);
                                        }
                                    });
                                }
                            };
                            img.src = objectUrl;
                        }
                    },
                    deleteImage(image) {
                        var index = this.$data.images.indexOf(image);
                        if (index !== -1) {
                            this.$data.images.splice(index, 1);
                        }
                    },
                    setMain(index) {
                        const url = this.$data.images[index];
                        this.$data.images.splice(index, 1);
                        this.$data.images.unshift(url);
                    },
                    showSlider(index) {
                        if(this.$data.moderator){
                            if(!$("#overlay", parent.document).length){
                                this.createSlider(index);
                            }else{
                                const url = '/' + this.$data.images[index];
                                const $overlay = $('#overlay', parent.document);
                                const $image = $("#overlay img", parent.document);
                                $image.attr("src", url);
                                $overlay.hide().delay(500).fadeIn("slow");
                            }
                        }

                    },
                    createSlider(index = 0){
                        const $overlay = $('<div id="overlay" ></div>');
                        const $image = $("<img>");
                        const $prevButton = $('<div id="prevButton"><span><</span></div>');
                        const $nextButton = $('<div id="nextButton"><span>></span></div>');
                        const $exitButton = $('<div id="exitButton"><span>X</span></div>');

// Add overlay
                        $overlay.append($image).prepend($prevButton).append($nextButton).append($exitButton);
                        $('body', parent.document).append($overlay);

// Hide overlay on default
                        // $overlay.hide();
                         this.showSlider(index);
                    }
                },
            });
        });
    }
    $('body', parent.document).on('click touchstart','#nextButton', function (event) {
        // Hide the current image
        $("#overlay img", parent.document).hide();
        // Overlay image location
        var $currentImgSrc = $("#overlay img", parent.document).attr("src");
        // Image with matching location of the overlay image
        var $currentImg = $('.uploaded-image img[src="' + $currentImgSrc + '"]');
        // Finds the next image
        var $nextImg = $($currentImg.closest(".uploaded-image").next().find("img"));
        // All of the images in the gallery
        var $images = $(".uploaded-images img");
        // If there is a next image
        if ($nextImg.length > 0) {
            // Fade in the next image
            $("#overlay img", parent.document).attr("src", $nextImg.attr("src")).show();
        } else {
            // Otherwise fade in the first image
            $("#overlay img", parent.document).attr("src", $($images[0]).attr("src")).show();
        }
        // Prevents overlay from being hidden
        event.stopPropagation();
    });

// When previous button is clicked
    $('body',parent.document).on('click touchstart','#prevButton',function (event) {
        // Hide the current image
        $("#overlay img", parent.document).hide();
        // Overlay image location
        var $currentImgSrc = $("#overlay img", parent.document).attr("src");
        // Image with matching location of the overlay image
        var $currentImg = $('.uploaded-image img[src="' + $currentImgSrc + '"]');
        // Finds the next image
        var $nextImg = $($currentImg.closest(".uploaded-image").prev().find("img"));
        // Fade in the next image
        var $images = $(".uploaded-images img");
        if ($nextImg.length > 0) {
            // Fade in the next image
            $("#overlay img", parent.document).attr("src", $nextImg.attr("src")).show();
        } else {
            // Otherwise fade in the first image
            $("#overlay img", parent.document).attr("src", $($images[$images.length - 1]).attr("src")).show();
        }
        // Prevents overlay from being hidden
        event.stopPropagation();
    });

// When the exit button is clicked
    $('body',parent.document).on('click touchstart','#exitButton',function (event) {
        // Fade out the overlay
        $("#overlay", parent.document).fadeOut("slow");
        event.stopPropagation();
    });

});